/* eslint-disable react/no-unsafe */
import React, { Component } from 'react';

import { ToKolonnerMedBillederProps, ToKolonnerMedBillederState } from './toKolonnerMedBilleder.definition';

export class ToKolonnerMedBilleder extends Component<ToKolonnerMedBillederProps, ToKolonnerMedBillederState> {
	constructor(props: any) {
		super(props);
		this.state = {
			width: window.innerWidth
		};
	}

	UNSAFE_componentWillMount() {
		window.addEventListener('resize', this.handleWindowSizeChange);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleWindowSizeChange);
	}

	handleWindowSizeChange = () => {
		this.setState({ width: window.innerWidth });
	};

	render() {
		const { width } = this.state;
		let isMobile = width <= 400;

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			isMobile = true;
		}

		const top =
			isMobile ? (
				<div>
					<div className="toKolonnerMedBilleder row base-band" style={ { backgroundColor: this.props.backgroundColor } }>
						<div className="row columns ">
							<section className="columns small-12 " >
								<h1 dangerouslySetInnerHTML={ { __html: this.props.overskrift } } />
							</section>
							<section className="columns small-12" >
								<span dangerouslySetInnerHTML={ { __html: this.props.beskrivelse } } />
							</section>
						</div>
						<div className="row columns paddingSmall">
							<div className="columns small-12 center">
								<img src={ this.props.imageLeft } />
							</div>

							<section className="columns small-12" >
								<span dangerouslySetInnerHTML={ { __html: this.props.textLeft } } />
							</section>
						</div>
						<div className="row columns paddingSmall">
							<div className="columns small-12 center">
								<img src={ this.props.imageRight } />
							</div>

							<section className="columns small-12" >
								<span dangerouslySetInnerHTML={ { __html: this.props.textRight } } />
							</section>
						</div>
					</div>
				</div>
			)
				: (
					<div>
						<div className="toKolonnerMedBilleder row base-band" style={ { backgroundColor: this.props.backgroundColor } }>
							<div className="row columns ">
								<section className="columns medium-12 " >
									<h1 dangerouslySetInnerHTML={ { __html: this.props.overskrift } } />
								</section>
								<section className="columns medium-10" >
									<span dangerouslySetInnerHTML={ { __html: this.props.beskrivelse } } />
								</section>
								<div className="columns medium-2" />
							</div>
							<div className="row">
								<div className="columns paddingSmall">
									<div className="columns medium-1 imageLeft">
										<img src={ this.props.imageLeft } />
									</div>

									<section className="columns medium-5" >
										<span dangerouslySetInnerHTML={ { __html: this.props.textLeft } } />
									</section>

									<div className="columns medium-1 imageRight">
										<img src={ this.props.imageRight } />
									</div>

									<section className="columns medium-5" >
										<span dangerouslySetInnerHTML={ { __html: this.props.textRight } } />
									</section>
								</div>
							</div>
						</div>
					</div>
				);

		return (
			<div>
				{ top }
			</div>
		);
	}
}

export default ToKolonnerMedBilleder;